module.exports = __webpack_public_path__ + "img/ic_share_ig.2242de7.svg";